import FormFieldViewText from "components/FormFields/ViewText";

type VCSIntegrationsUseGitCheckoutInfoProps = {
  value: boolean;
};

const VCSIntegrationsUseGitCheckoutInfo = ({ value }: VCSIntegrationsUseGitCheckoutInfoProps) => {
  return <FormFieldViewText label="Use Git checkout" value={value ? "Yes" : "No"} />;
};

export default VCSIntegrationsUseGitCheckoutInfo;
